import { Table, Typography } from 'antd'
import React from 'react'
import { UsePaginationTableProps } from '../../hooks/use-pagination'
import { TimeAgo } from '../../components/time-ago'
import { Candidate, CandidateStatus } from '../candidate'
import { CandidateAvatar } from './candidate-avatar'
import { useTranslation } from 'react-i18next'
import { candidateStatusTableFilters, CandidateStatusTag } from './candidate-status-tag'
import { useCampaigns } from '../../campaign/hooks'

export type CandidateTableProps = UsePaginationTableProps<Candidate>

export function CandidateTable({ withColumnDefaults, ...props }: CandidateTableProps) {
    const { t } = useTranslation()

    const campaigns = useCampaigns({ query: { size: 1000 } })

    return (
        <Table
            size="small"
            {...props}
            rowClassName="cursor-pointer"
            scroll={{
                x: 800,
                y: 800,
            }}
            columns={withColumnDefaults([
                {
                    dataIndex: 'avatar',
                    width: 40,
                    key: 'avatar',
                    render(_, record) {
                        return <CandidateAvatar candidate={record} />
                    },
                },
                {
                    title: t('Status'),
                    dataIndex: 'status',
                    key: 'status',
                    width: 120,
                    sorter: true,
                    filters: candidateStatusTableFilters,
                    render(status: CandidateStatus) {
                        return <CandidateStatusTag status={status} />
                    },
                },
                {
                    title: t('Name'),
                    dataIndex: 'name',
                    key: 'name',
                    sorter: true,
                    render(name) {
                        return <Typography.Text ellipsis>{name}</Typography.Text>
                    },
                },

                {
                    title: t('Campaign'),
                    dataIndex: 'campaignId',
                    key: 'campaignId',
                    sorter: true,
                    filters: campaigns.data?.data.map((campaign) => ({ value: campaign.id, text: campaign.title })),
                    render(campaign, record) {
                        return <Typography.Text ellipsis>{record?.campaign?.title}</Typography.Text>
                    },
                },
                {
                    title: t('Phone'),
                    dataIndex: 'phone',
                    key: 'phone',
                    width: 140,
                    render(phone) {
                        return <Typography.Link href={`tel:${phone}`}>{phone}</Typography.Link>
                    },
                },
                {
                    dataIndex: 'compatibility',
                    key: 'compatibility',
                    sorter: true,
                    width: 75,
                    align: 'right',
                    render(compatibility) {
                        if (compatibility === null) return '-'
                        return (
                            <>
                                {compatibility >= 70 && <>🏆</>} {compatibility}%
                            </>
                        )
                    },
                },
                {
                    title: t('Created'),
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    width: 180,
                    render(date) {
                        return <TimeAgo date={date} />
                    },
                    sorter: true,
                },
            ])}
        />
    )
}
